export interface Trimestre {
    trimestre: number;
    abreviacao: string
    nome: string;
}

export const trimestre1: Trimestre = {trimestre: 1, abreviacao: 'T1', nome: 'Trimestre 1'};
export const trimestre2: Trimestre = {trimestre: 2, abreviacao: 'T2', nome: 'Trimestre 2'};
export const trimestre3: Trimestre = {trimestre: 3, abreviacao: 'T3', nome: 'Trimestre 3'};
export const trimestre4: Trimestre = {trimestre: 4, abreviacao: 'T4', nome: 'Trimestre 4'};


export const trimestres: Trimestre[] = [
    trimestre1,
    trimestre2,
    trimestre3,
    trimestre4
];
